"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin: 0 auto;\n  border-bottom: 1px solid #979797;\n  padding: 20px 0;\n  box-sizing: border-box;\n\n  ", ";\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootContainer = void 0;

var _core = require("@emotion/core");

var _mediaQueries = require("../../utils/mediaQueries");

var rootContainer = function rootContainer(_ref) {
  var _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth;
  return (0, _core.css)(_templateObject(), !fullWidth && 'max-width: 570px', (0, _mediaQueries.mq)({
    flexDirection: ['column', 'column', 'column', 'row', 'row', 'row']
  }));
};

exports.rootContainer = rootContainer;